module.exports = __webpack_public_path__ + "img/github-mark.8dcc6b52.svg";